export const SOLUTION_TYPES = ['ofac', 'dod', 'fintech', 'education', 'website'] as const;
export type SolutionType = (typeof SOLUTION_TYPES)[number];

export const CONVERSION_TIERS = ['A', 'B', 'C'] as const;
export type ConversionTier = (typeof CONVERSION_TIERS)[number];

export const LEAD_SORTS = [
  { id: 'conversion', en: 'Conversion', es: 'Conversión' },
  { id: 'proximity', en: 'Proximity', es: 'Proximidad' },
  { id: 'company', en: 'Company', es: 'Empresa' },
  { id: 'id', en: 'Newest', es: 'Más recientes' },
] as const;

export type LeadBookQuery = {
  campaignId?: number | null;
  solutionType?: string;
  conversionTier?: string;
  q?: string;
  sort?: string;
  order?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
  salesReady?: boolean;
};

export const leadQueryPath = (base: '/api/v1/pursuit/leads/query' | '/api/v1/pursuit/tam-accounts', query: LeadBookQuery): string => {
  const params = new URLSearchParams();
  if (query.campaignId) params.set('campaign_id', String(query.campaignId));
  if (query.solutionType) params.set('solution_type', query.solutionType);
  if (query.conversionTier) params.set('conversion_tier', query.conversionTier);
  if (query.q) params.set('q', query.q);
  if (query.sort) params.set('sort', query.sort);
  if (query.order) params.set('order', query.order);
  if (typeof query.limit === 'number') params.set('limit', String(query.limit));
  if (typeof query.offset === 'number') params.set('offset', String(query.offset));
  if (base.endsWith('/query') && query.salesReady === false) params.set('sales_ready', 'false');
  const encoded = params.toString();
  return encoded ? `${base}?${encoded}` : base;
};

export const asLeadPage = (payload: unknown, fallback: unknown[] = []): { items: unknown[]; total: number } => {
  if (payload && typeof payload === 'object' && Array.isArray((payload as { items?: unknown }).items)) {
    const page = payload as { items: unknown[]; total?: number };
    return { items: page.items, total: Number(page.total || page.items.length) };
  }
  if (Array.isArray(payload)) return { items: payload, total: payload.length };
  return { items: fallback, total: fallback.length };
};
